import React from "react";
import PropTypes from 'prop-types';

import styles from './breadcrumbs.module.css';

/**
 * @param {string | JSX} separator what seperates various links
 * @param {number} maxItems this shows how many items we want to show, the other should be replaced with ellipses
 * 
 * @returns {JSX.Element}
 */
const Breadcrumbs = ({separator="/", maxItems, className, children, ...props}) => {
    const Children = React.Children.toArray(children);
    let toDisplay = []
    if(maxItems && Children.length > maxItems){
        toDisplay.push(Children[0]);
        toDisplay.push(<p style={styles.more}>...</p>);
        toDisplay.push(Children.slice(Children.length - maxItems -1))
    }
    else{
        toDisplay = Children;
    }
    toDisplay = toDisplay.map((child, ind )=> {
       return ind === toDisplay.length -1 ? (
          child 
       ): (
        <div className={`${styles.item}`}>
            {child}
            <p>{separator}</p>
        </div>
       )
    })
    return (
        <div className={`${styles.Breadcrumbs} ${className || ""}`} {...props}>{toDisplay}</div>
    )
}

Breadcrumbs.propTypes = {
    separator: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    maxItems: PropTypes.number
}
export default Breadcrumbs